import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/dashboard/Dashboard';
import DeveloperGuide from '@/components/developerGuide/DeveloperGuide';
import Login from '@/components/login/LoginPage';
import ListCompatibleScenarios from '@/components/identifyCompatibleScenarios/ListCompatibleScenarios';
import ConflictResolution from '@/components/conflictResolution/ConflictResolution';
import ConflictsResolution from '@/components/conflictResolution/ConflictsResolution';
import Editor from '@/components/editor/Editor';
import ElementsList from '@/components/editor/ElementsList';
import Play from '@/components/play/Play';
import PlaySourceViewer from '@/components/play/SourceViewer';
import Profile from '@/components/profile/Profile';
import Register from '@/components/login/Register';
import NotFound from '@/components/global/NotFound';
import DecisionPolicyViewer from '@/components/viewer/DecisionPolicyViewer';

import { Auth } from '@aws-amplify/auth';

Vue.use(Router);

// TODO: externaliser quand on aura besoin de plusieurs navigation guards
function isUserAuthenticated (to, from, next) {
  Auth.currentSession().then(() => {
    if (to.name === 'login') {
      next({ name: 'dashboard' });
    }
    next();
  }).catch(err => {
    // TODO: a voir, peut-etre affiner ce check
    console.log("error : ", err);
    next({ name: 'login' });
  });
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/search/:query',
      name: 'searchProjects',
      component: Dashboard,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/compatiblesScenarios',
      name: 'compatiblesScenarios',
      component: ListCompatibleScenarios,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/conflictsResolution',
      name: 'conflictsResolution',
      component: ConflictsResolution,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/conflictsResolution/:conflict',
      name: 'conflictResolution',
      component: ConflictResolution,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/editor',
      name: 'editor',
      component: Editor,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/viewer',
      name: 'viewer',
      component: DecisionPolicyViewer,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/elements',
      name: 'elements',
      component: ElementsList,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/run',
      name: 'play',
      component: Play,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/sources',
      name: 'playSourceViewer',
      component: PlaySourceViewer,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/developer',
      name: 'developerGuide',
      component: DeveloperGuide,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '*',
      name: '4040NotFound',
      component: NotFound,
      beforeEnter: isUserAuthenticated,
    }
  ],
});
